import React, { useEffect, useState } from "react";
import ApiServices from "../../../service/apiService";
import { FormattedMessage, useIntl } from "react-intl";
import {
  Box,
  Button,
  Checkbox,
  Pagination,
  PaginationItem,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import Account from "../../../utils/apiConfig";
import ErrorHandler from "../../../utils/errorConfig";
import { CreateCohort, FetchAllUsers, User1 } from "@mikros/library";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Alert } from "@mikros/shared-ui";

export interface SearchCriteriaDupProps {
  state: string;
  cohortName: any;
  description: any;
  cohortLandState: Function;
  textBoxState: Function;
  refreshedCohorts: () => void;
  newCohortState: () => void;
  errorState: Function;
  searchCriteriaState: Function;
  formState: Function;
  userData: FetchAllUsers;
  userDataFunction: Function;
  search: boolean;
  searchFunction: Function;
  totalCount: number;
  totalCountFunction: Function;
  formData: any;
  formDataFunction: Function;
  hasMoreDataReference: any;
  validateAndSetError: Function;
  selectedLanguageFunction: Function;
  selectedLanguage: any;
  languages: any;
}

export function SearchCriteriaDup(props: SearchCriteriaDupProps) {
  const theme = createTheme({
    components: {
      MuiButtonBase: {
        defaultProps: {
          disableRipple: true,
        },
      },
    },
  });
  const allValue = "All";
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [lastKey, setLastKey] = useState<any>("");

  const [errorFlag, setErrorFlag] = useState<boolean>(false);
  const intl = useIntl();
  const accountInstance = Account.getInstance();
  const errorInstance = ErrorHandler.getErrorInstance();
  const totalPages =
    props?.userData.users?.length > 0
      ? Math.ceil(props?.userData.users?.length / rowsPerPage)
      : 1;
  const [page, setPage] = useState(0);

  interface SelectedUser {
    empId: string;
    // Add other properties if necessary
  }

  console.log("props search", props.search);
  const [selectedUsers, setSelectedUsers] = React.useState<{
    [id: string]: boolean | number[];
  }>({});
  const [createCohort, setCreateCohort] = useState<CreateCohort>({
    users: [{} as User1],
  } as CreateCohort);
  const [formDialog, setformDialog] = React.useState<boolean>(false);

  console.log("selected users print", selectedUsers);
  const cohortNameRegex: RegExp = new RegExp(/^[a-zA-Z0-9\s.]+$/);

  const cohortDescRegex: RegExp = new RegExp(/^(?:[a-zA-Z0-9\s.#-]+)?$/);

  const paginatedData = props.search
    ? rowsPerPage === -1
      ? props?.userData?.users
      : props?.userData?.users?.slice(
          page * rowsPerPage,
          page * rowsPerPage + rowsPerPage
        )
    : rowsPerPage === -1
    ? props?.userData?.users
    : props?.userData?.users?.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      );

  const selectedKeys = Object.keys(selectedUsers);
  // const isAllSelected = selectedKeys?.length === paginatedData?.length;
  const isAllSelected =
    paginatedData.length > 0 && // Ensure data exists
    paginatedData.every((row) => selectedUsers[row.userId] === true);

  const isIndeterminate =
    selectedKeys.length > 0 && selectedKeys?.length < paginatedData?.length;

  const handleItemClick = (lang: string) => {
    let updatedSelection = [...props.selectedLanguage];
    if (lang === allValue) {
      updatedSelection = [...props.languages];
    } else {
      if (updatedSelection.includes(lang)) {
        updatedSelection = updatedSelection.filter((l) => l != lang);
      } else {
        updatedSelection.push(lang); //check
      }
    }
    if (updatedSelection.length === props.languages.length) {
      updatedSelection = [...props.languages];
    }
    // setSelectedLanguage(updatedSelection);
    props.selectedLanguageFunction(updatedSelection);
  };

  const toggleformDialog = () => {
    setformDialog(!formDialog);
  };

  const toTitleCase = (value: any) => {
    if (typeof value === "string") {
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    }
    return value ?? ""; // Return the original value if not a string, or "N/A" if null/undefined
  };
  const signIn = () => {
    if (!props.validateAndSetError()) {
      return;
    }
    console.log("inside signin of add selected to cohort");
    let body = createCohort;
    body.users = [];

    body.cohortName = props.cohortName;
    body.accntId = accountInstance.accntId;

    console.log("cohort Name in signIn", body.cohortName);
    body.cohortType = "STATIC";
    body.createdBy = "40c60358-adf4-415c-bed3-f542efd4bbc6";
    body.date = "2022-11-23T12:21:00.060Z";
    body.description = props.description;
    body.entryType = "COHORT";
    body.status = "ACTIVE";
    body.updatedBy = "2f413330-4cc7-49a8-94f6-6ae2e894260e";

    let userData = body.users;

    console.log("Initial user data", userData);

    const selectedKeys = Object.keys(selectedUsers);

    console.log("Selected state keys structure", selectedKeys);
    selectedKeys.forEach((key) => {
      if (selectedUsers[key]) {
        console.log("if condition", selectedUsers[key]);
        const newUser = {
          userId: key,
          // empId: item.empId
          empId: selectedUsers[key].toString(),
        };
        console.log("New user data in create cohort", newUser);
        userData.push(newUser);
      }

      // if (selectedUsers) {
      //   console.log("if condition", selectedUsers);
      //   const newUser = {
      //     userId: key,
      //     // empId: item.empId
      //     empId: selectedUsers.toString(),
      //   };
      //   console.log("New user data in create cohort", newUser);
      //   userData.push(newUser);
      // }

      if (selectedUsers && Object.keys(selectedUsers)?.length > 0) {
        console.log("Selected users:", selectedUsers);

        // Convert selectedUsers into an array of user objects
        // body.users = Object.keys(selectedUsers).map((userId) => ({
        //   userId,
        //   empId:""
        //   // empId: selectedUsers[userId]?.toString() || "", // Ensure empId is a string
        // }));

        body.users = Object?.entries(selectedUsers).map(
          ([userId, userData]) => ({
            userId: userId,
            empId: "",
            // empId: userData.empId || "",
          })
        );

        console.log("Final user data in cohort", body.users);
      } else {
        console.log("No users selected!");
      }
    });

    console.log("after assign of user data in create cohort", userData);
    body.cohortuserCnt = userData.length;
    console.log("check cohort user cnt", body?.cohortuserCnt);

    if (
      props.cohortName &&
      cohortNameRegex.test(props?.cohortName) &&
      cohortDescRegex.test(props?.description)
    ) {
      let api = ApiServices.getInstance();
      if (accountInstance.accntId) {
        api
          .makeRequest(`${accountInstance.accntId}/cohort`, "POST", body)
          .then(async (body) => {
            if (body && body.errorMessage) {
              setErrorFlag(true);
              await errorInstance.updateErrorCode(body.errorMessage);
              return;
            }
            console.log("Create Form response cohorts", body);
            console.log("User id display", Object.keys(selectedUsers)[0]);
            setformDialog(!formDialog);
          });
      }
    }
  };
  const addEverything = async () => {
    try {
      if (!props.validateAndSetError()) {
        return;
      }

      console.log("Checking if search is active...");

      let body = { ...createCohort };
      body.users = [];
      body.accntId = accountInstance.accntId;
      body.cohortName = props.cohortName;
      body.cohortType = "STATIC";
      body.createdBy = "40c60358-adf4-415c-bed3-f542efd4bbc6";
      body.date = "2022-11-23T12:21:00.060Z";
      body.description = props.description;
      body.entryType = "COHORT";
      body.status = "ACTIVE";
      body.updatedBy = "2f413330-4cc7-49a8-94f6-6ae2e894260e";

      if (props.search) {
        console.log(
          "Search is active, using filtered users from props.userData..."
        );

        if (Array.isArray(props?.userData?.users)) {
          body.users = props?.userData?.users
            .filter((item) => item?.userId) // Ensure userId exists
            .map((item) => ({
              userId: item?.userId,
              empId: item?.empId || "", // Ensure empId is always a string
            }));
        } else {
          console.warn("props.userData.users is not an array!", props.userData);
          return; // Exit to prevent errors
        }
      }

      console.log("After assigning user data:", body?.users);
      body.cohortuserCnt = body.users.length;
      console.log("Final cohort user count:", body?.cohortuserCnt);
      console.log(
        "Cohort Name Validation:",
        cohortNameRegex.test(props.cohortName)
      );

      if (
        props.cohortName &&
        cohortNameRegex.test(props?.cohortName) &&
        cohortDescRegex.test(props?.description)
      ) {
        let api = ApiServices.getInstance();
        if (accountInstance.accntId) {
          const response = await api.makeRequest(
            `${accountInstance.accntId}/cohort`,
            "POST",
            body
          );

          if (response && response.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(response.errorMessage);
            return;
          }

          console.log("Create Form Response Cohorts:", response);
          console.log(
            "After Post Request - User Count:",
            response.cohortuserCnt
          );

          setformDialog(!formDialog);
        }
      }
    } catch (error) {
      console.error("Error in addEverything:", error);
    }
  };

  const handleSelectUser = (userId: string) => {
    // setSelectedUsers((prevSelected) => ({
    //   ...prevSelected,
    //   [userId]: prevSelected[userId] ? false : true,
    // }));

    setSelectedUsers((prevSelected) => ({
      ...prevSelected,
      [userId]: !prevSelected[userId], // Toggle selection (true/false)
    }));
  };

  // Function to handle "Select All"
  // const handleSelectAll = () => {
  //   if (selectedUsers.length === paginatedData.length) {
  //     setSelectedUsers([]); // Unselect all
  //   } else {
  //     setSelectedUsers(paginatedData.map((user) => user.userId)); // Select all
  //   }
  // };

  // const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   if (event.target.checked) {
  //     const newSelected = paginatedData?.reduce((acc, user) => {
  //       acc[user.userId] = true; //select all
  //       return acc;
  //     }, {} as { [id: string]: boolean });
  //     setSelectedUsers(newSelected);
  //   } else {
  //     setSelectedUsers({}); //deseclect all
  //   }
  // };

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newSelectedState = event.target.checked;

    setSelectedUsers((prevSelected) => {
      const updatedSelection = { ...prevSelected };

      paginatedData.forEach((row) => {
        updatedSelection[row.userId] = newSelectedState; // Select or unselect all rows
      });

      return updatedSelection;
    });
  };

  const handleChangePage = async (event: any, newPage: number) => {
    setPage(newPage - 1);
    console.log("click of handle change page");
    console.log("props.search value", props?.search);

    if (!loading && !props?.search) {
      // props.refreshDataReference.current = true; //  Enable data loading on user action

      if (props?.hasMoreDataReference?.current) {
        fetchUsers(rowsPerPage, lastKey); //  Fetch only if more data exists
      }
    }
  };

  // const handleRowsPerPageChange = (event: { target: { value: string } }) => {
  //   props.formDataFunction({
  //     designation: "", // Reset all fields to empty or their default value
  //     firstName: "",
  //     branchName: "",
  //     location: "",
  //     department: "",
  //   });
  //   const newRowsPerPage = parseInt(event.target.value, 10);
  //   console.log("Rows per page change value:", newRowsPerPage);

  //   setRowsPerPage(newRowsPerPage);
  //   setPage(0); // Reset to first page
  //   // props.pageFunction(0)

  //   setLastKey(null); // Reset pagination key
  //   // setTotalUsers(0)// reset user count
  //   props.searchFunction(false);
  //   props.userDataFunction({ users: [] }); // clear previous user data
  //   props.selectedLanguageFunction([allValue]);
  //   handleItemClick(allValue);

  //   fetchUsers(newRowsPerPage, ""); // Use newRowsPerPage directly
  // };

  const handleRowsPerPageChange = (event: { target: { value: string } }) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    console.log("Rows per page change value", newRowsPerPage);
    setRowsPerPage(newRowsPerPage);
    if (!props.search) {
      props.formDataFunction({
        firstName: "",
        branchName: "",
        department: "",
        location: "",
        designation: "",
        email: "",
        phNo: "",
      });
      setPage(0);
      setLastKey(null);
      props.searchFunction(false);
      props.userDataFunction({ users: [] });
      props.selectedLanguageFunction([allValue]);
      handleItemClick(allValue);
      fetchUsers(newRowsPerPage, "");
    }
  };

  function fetchUsers(limit: number, key: string) {
    let api = ApiServices.getInstance();
    if (limit === -1) {
      setLoading(true);
      console.log("inside limit equal -1");
      api
        .makeRequest(`${accountInstance.accntId}/user`, "GET")
        .then(async (data) => {
          if (data && data?.errorMessage) {
            console.log("entered error code handling in user details");
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          } else {
            // props.userDataFunction(data);
            // const totalUserCount = data?.users?.length;
            // props.totalCountFunction(totalUserCount);
            // setLoading(false);
            // props.hasMoreDataReference.current = !!data?.lastKey;

            const activeUsers =
              data?.users?.filter((user: any) => user.status === "ACTIVE") ||
              [];
            props.userDataFunction({ ...data, users: activeUsers });
            props.totalCountFunction(activeUsers.length);
            setLoading(false);
            props.hasMoreDataReference.current = !!data?.lastKey;
          }
        });
      return;
    }
    if (accountInstance.accntId && key === "") {
      setLoading(true);

      console.log("entered when last key is null");
      api
        .makeRequest(`${accountInstance.accntId}/user?limit=20`, "GET")
        .then(async (data) => {
          if (data && data.errorMessage) {
            console.log(
              "I entered error code handling in user course analytics when last key is null"
            );
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          } else {
            // props.userDataFunction(data);
            // const totalUserCount = data?.users?.length;
            // props.totalCountFunction(totalUserCount);
            // setLastKey(data.lastKey);

            // props.hasMoreDataReference.current = !!data.lastKey;
            // setLoading(false);

            const activeUsers =
              data?.users?.filter((user: any) => user.status === "ACTIVE") ||
              [];
            props.userDataFunction({ ...data, users: activeUsers });
            props.totalCountFunction(activeUsers.length);
            setLastKey(data.lastKey);
            props.hasMoreDataReference.current = !!data.lastKey;
            setLoading(false);
          }
        });
    }

    //need to check if correct// because duplicated maybe present
    else if (accountInstance.accntId && key !== null) {
      setLoading(true);
      console.log("Fetching next page with lastKey:", key);
      api
        .makeRequest(
          `${accountInstance.accntId}/user?limit=${limit}&lastKey=${key}`,
          "GET"
        )
        .then(async (data) => {
          if (data && data.errorMessage) {
            console.log(
              "I entered error code handling in user course analytics when last key is not null"
            );
            setErrorFlag(true);
            await errorInstance.updateErrorCode(data.errorMessage);
            return;
          } else {
            // Append only when paginating
            // props.userDataFunction((prevData: any) => ({
            //   ...prevData,
            //   users: [...prevData?.users, ...data?.users],
            // }));
            // props.totalCountFunction(
            //   (prevCount: any) => prevCount + (data?.users?.length || 0)
            // );
            // setLastKey(data.lastKey);

            // props.hasMoreDataReference.current = !!data.lastKey;
            // setLoading(false);

            const activeUsers =
              data?.users?.filter((user: any) => user.status === "ACTIVE") ||
              [];
            props.userDataFunction((prevData: any) => ({
              ...prevData,
              users: [...prevData?.users, ...activeUsers],
            }));
            props.totalCountFunction(
              (prevCount: any) => prevCount + activeUsers.length
            );
            setLastKey(data.lastKey);
            props.hasMoreDataReference.current = !!data.lastKey;
            setLoading(false);
          }
        });
    }
  }

  useEffect(() => {
    // if (!fetchedDataBefore) {
    // if (!fetchedDataBefore && hasMoreDataRef.current) {
    // if (!fetchedDataBefore && props.refreshDataReference.current) {
    console.log("inside use effect where I am fetching data");

    fetchUsers(rowsPerPage, lastKey);
    // }
  }, [accountInstance.accntId]);
  useEffect(() => {
    if (page >= totalPages) {
      setPage(Math.max(totalPages - 1, 0));
    }
  }, [totalPages, page]);
  return (
    <div>
      {formDialog && (
        <Dialog className="confirmSuccessDialogue">
          <Alert
            description={intl.formatMessage({
              id: "user.searchCriteria.cohortSuccessMessage",
            })}
            buttonText={intl.formatMessage({ id: "users.buttonText.Ok" })}
            icon={"successShape.png"}
            iconMsg={intl.formatMessage({ id: "iconMsgSuccess" })}
            backgroundColor={"mk-bright-green"}
            onClick={() => {
              toggleformDialog();
              props.textBoxState(false);
              props.refreshedCohorts();
              props.cohortLandState(true);
              props.newCohortState();
            }}
          />
        </Dialog>
      )}
      <TableContainer
        component={Paper}
        style={{
          overflow: "auto",
          width: "100%",
          backgroundColor: "var(--color-mk-primary-10) !important",
        }}
        elevation={0}
      >
        <Table sx={{ width: "max-content", tableLayout: "auto" }} size="medium">
          <TableHead>
            <TableRow
              sx={{
                "&:hover": {
                  backgroundColor: "var(--color-mk-primary-10 ",
                },
              }}
            >
              <TableCell>
                <Checkbox
                  sx={{
                    transform: "scale(1.3)", // Increase size
                    color: "#6464E5", // Default color
                    "&.Mui-checked": {
                      color: "#FF5733", // Checked color
                    },
                    "& .MuiSvgIcon-root": {
                      fontSize: 28, // Adjust icon size
                    },
                  }}
                  // indeterminate={isIndeterminate}
                  checked={isAllSelected}
                  onChange={handleSelectAll}
                />
              </TableCell>
              <TableCell style={{ width: "13%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.fname"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "3%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.lname"></FormattedMessage>
              </TableCell>

              <TableCell style={{ width: "3%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.status"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "3%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.language"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "7%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.phNo"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "10%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.email"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "3%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.employee"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "2.5%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.dob"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "2.5%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.dateOfJoin"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "2.5%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.lastWorkingDate"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "3%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.gender"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "13%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.department"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "13%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.desg"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "10.5%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.location"></FormattedMessage>
              </TableCell>
              <TableCell style={{ width: "11%", whiteSpace: "nowrap" }}>
                <FormattedMessage id="user.searchUser.gridColumn.branch"></FormattedMessage>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedData.length > 0 ? (
              paginatedData.map(
                (
                  user: {
                    userId: any;
                    userProfile: {
                      firstName: string;
                      lastName: string;
                      dob: string | number | Date;
                      gender: any;
                    };
                    status: string;
                    prefrdLanguage: string;
                    phNo: string;
                    email: string;

                    empId: any;
                    dateOfJoin: string | number | Date;
                    lastWorkingDate: string | number | Date;
                    department: any;
                    designation: any;
                    location: any;
                    branchName: any;
                  },
                  index: any
                ) => {
                  // const isSelected = selectedUsers.includes(user.userId);
                  const isSelected = !!selectedUsers[user.userId];

                  return (
                    <TableRow
                      // sx={{
                      //   backgroundColor: "var(--color-mk-primary-10) !important",
                      //   cursor: "pointer",
                      //   "&:hover": {
                      //     backgroundColor: "var(--color-mk-primary-20) !important",
                      //   },
                      // }}

                      sx={{
                        backgroundColor: isSelected
                          ? "var(--color-mk-primary-50)"
                          : "transparent", // Light orange when selected
                        "&:hover": {
                          backgroundColor: isSelected
                            ? "var(--color-mk-primary-50) !important"
                            : "transparent",
                        },
                      }}
                      key={user.userId || index}
                      // onClick={() => handleGridItemClick(user)} // Pass the row data if needed
                    >
                      <TableCell>
                        <Checkbox
                          sx={{
                            transform: "scale(1.3)", // Increase size
                            color: "#6464E5", // Default color
                            "&.Mui-checked": {
                              color: "#FF5733", // Checked color
                            },
                            "& .MuiSvgIcon-root": {
                              fontSize: 28, // Adjust icon size
                            },
                          }}
                          // checked={selectedUsers.includes(user.userId)}
                          checked={!!selectedUsers[user.userId]}
                          onChange={() => handleSelectUser(user.userId)}
                        ></Checkbox>
                      </TableCell>
                      <TableCell>{user?.userProfile?.firstName}</TableCell>
                      <TableCell>{user?.userProfile?.lastName}</TableCell>
                      <TableCell>{toTitleCase(user?.status)}</TableCell>
                      <TableCell>{user?.prefrdLanguage}</TableCell>
                      <TableCell>{user?.phNo}</TableCell>
                      <TableCell>{user?.email}</TableCell>
                      <TableCell>{user?.empId || ""}</TableCell>
                      <TableCell>
                        {user?.userProfile?.dob
                          ? new Date(
                              user?.userProfile?.dob
                            ).toLocaleDateString()
                          : ""}
                      </TableCell>
                      <TableCell>
                        {user?.dateOfJoin
                          ? new Date(user?.dateOfJoin).toLocaleDateString()
                          : ""}
                      </TableCell>
                      <TableCell>
                        {user?.lastWorkingDate
                          ? new Date(user?.lastWorkingDate).toLocaleDateString()
                          : ""}
                      </TableCell>

                      <TableCell>
                        {toTitleCase(user?.userProfile?.gender || "")}
                      </TableCell>
                      <TableCell>{user?.department || ""}</TableCell>
                      <TableCell>{user?.designation || ""}</TableCell>
                      <TableCell>{user?.location || ""}</TableCell>
                      <TableCell>{user?.branchName || ""}</TableCell>
                    </TableRow>
                  );
                }
              )
            ) : (
              <TableRow>
                <TableCell colSpan={15} align="center">
                  <div className="w-full h-full flex items-center justify-center text-center text-lg text-mk-primary-bright font-semibold mt-4">
                    <FormattedMessage id="users.addNewUser.noUser" />
                  </div>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          sx={{
            // backgroundColor: "#F5F6FD",
            backgroundColor: "var(--color-mk-primary-10) !important",
            padding: 0, // Removes padding
          }}
        >
          <Box display="flex" justifyContent="center" alignItems="center">
            <ThemeProvider theme={theme}>
              <Pagination
                count={totalPages}
                page={page + 1}
                onChange={handleChangePage}
                variant="text" //Removes border and background color
                shape="rounded"
                showFirstButton
                showLastButton
                siblingCount={1}
                renderItem={(item) => (
                  <PaginationItem
                    {...item}
                    disabled={
                      (item.type === "next" &&
                        // !hasMoreData &&
                        // !hasMoreDataRef &&
                        !props.hasMoreDataReference.current &&
                        page === totalPages - 1) ||
                      ((item.type === "previous" || item.type === "first") &&
                        page === 0) ||
                      (item.type === "last" &&
                        // !hasMoreData &&
                        // !hasMoreDataRef &&
                        !props.hasMoreDataReference.current &&
                        page === totalPages - 1)
                    }
                  />
                )}
              />
            </ThemeProvider>

            <TablePagination
              rowsPerPageOptions={[
                5,
                10,
                15,
                25,
                { label: intl.formatMessage({ id: "allValue" }), value: -1 },
              ]}
              component="div"
              // count={userModelData?.length}
              //   count={props?.userDataCont.users?.length}

              // count={totalUsers}
              count={props?.totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={(event, newPage) => setPage(newPage)}
              onRowsPerPageChange={handleRowsPerPageChange}
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} 
       
              ${intl.formatMessage({ id: "ofValue" })}
               ${count}
               ${intl.formatMessage({ id: "items" })}
                `
              }
              ActionsComponent={() => null} // to remove navigation buttons
              sx={{
                color: "#6464E5",
              }}
            />
          </Box>
        </Stack>
      </TableContainer>

      <div className="flex justify-end gap-6">
        <Button
          type="button"
          variant="contained"
          disableRipple
          sx={{
            mt: 2,
            borderRadius: "8px",
            textTransform: "capitalize",
            color: "white",

            backgroundColor: "#6464E5",
            "&:hover": {
              backgroundColor: "#E1E2E9",
              color: "black",
            },
            display: "inline-block",
          }}
          // onClick={signIn}
          onClick={(e) => {
            e.preventDefault(); // Prevent form submission if inside a <form>
            e.stopPropagation(); // Prevent event bubbling issues
            signIn();
          }}
          disabled={
            Object.keys(selectedUsers).length === 0 ||
            Object.values(selectedUsers).every((value) => !value)
          }
        >
          <FormattedMessage id="user.searchCriteria.addSelectedToCohort"></FormattedMessage>
        </Button>
        <Button
          type="submit"
          variant="contained"
          disableRipple
          sx={{
            mt: 2,
            borderRadius: "8px",
            textTransform: "capitalize",
            color: "white",

            backgroundColor: "#6464E5",
            "&:hover": {
              backgroundColor: "#E1E2E9",
              color: "black",
            },
            display: "inline-block",
          }}
          disabled={!props.search}
          // onClick={addEverything}
          onClick={(e) => {
            e.preventDefault(); // Prevent form submission if inside a <form>
            e.stopPropagation(); // Prevent event bubbling issues
            addEverything();
          }}
        >
          <FormattedMessage id="user.searchCriteria.addEverythingToCohort"></FormattedMessage>
        </Button>
      </div>

      <div className="pb-[15%]"></div>
    </div>
  );
}
